import DetailModal from './DetailModal/DetailModal';
import ItemBox from './ItemBox/ItemBox';
import ShareModal from './ShareModal/ShareModal';
import useProductItem from './useProductItem';

const url = window.location.origin;

const ProductItem = ({ data, isInSearchPage, productDetailId }) => {
  const [
    shareModal,
    setShareModal,
    isModalVisible,
    HideModal,
    showModal_visible,
    add_to_cart,
    store,
    history
  ] = useProductItem({ productDetailId });

  return (
    <>
      <ItemBox
        add_to_cart={add_to_cart}
        data={data}
        isInSearchPage={isInSearchPage}
        setShareModal={setShareModal}
        showModal_visible={showModal_visible}
      />

      <ShareModal
        setShareModal={setShareModal}
        shareModal={shareModal}
        value={`${url}${history.location.pathname}#sproduct-${data.id}`}
      />

      <DetailModal
        add_to_cart={add_to_cart}
        data={data}
        HideModal={HideModal}
        isModalVisible={isModalVisible}
        setShareModal={setShareModal}
        showShare={true}
        store={store}
      />
    </>
  );
};

export default ProductItem;
